module.exports = __webpack_public_path__ + "static/media/neverPayAFineIcon.b9f5606c.svg";